import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BRAND, NAV } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 bg-ink-900 px-5 pt-20 pb-10 md:px-10">
    <div className="mx-auto max-w-[1400px]">
      <div className="flex flex-col gap-8 border-b border-white/10 pb-16 md:flex-row md:items-end md:justify-between">
        <h2 className="font-head text-[16vw] font-medium leading-[0.82] tracking-tight text-white md:text-[11vw] lg:text-[9rem]">
          Let's <span className="text-stroke">Talk</span>
        </h2>
        <Link
          to="/contact"
          data-testid="footer-cta"
          className="group inline-flex w-fit items-center gap-3 rounded-full bg-amber px-8 py-4 font-medium uppercase tracking-[0.2em] text-black transition-transform duration-300 hover:scale-[1.04]"
        >
          Book a Consultation
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </Link>
      </div>

      <div className="grid gap-10 py-14 md:grid-cols-4">
        <div>
          <div className="font-head text-2xl font-medium tracking-tight text-white">7 Electric Advice</div>
          <p className="mt-3 max-w-xs text-sm text-white/50">
            Advisory with Manny Diaz. 40+ years of licensed residential, commercial & industrial electrical expertise.
          </p>
          <a href="https://7electricadvice.com" className="mt-4 inline-block text-sm font-semibold text-amber hover:text-amber/80">7electricadvice.com</a>
        </div>
        <div>
          <div className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-amber">Explore</div>
          <ul className="space-y-3">
            {[...NAV, { label: "Contact", to: "/contact" }].map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-white/60 transition-colors hover:text-white">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-amber">Contact</div>
          <ul className="space-y-3 text-sm text-white/60">
            <li><a href={BRAND.phoneHref} className="flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4 text-amber" />{BRAND.phone}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4 text-amber" />{BRAND.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-amber" />{BRAND.address}</li>
          </ul>
        </div>
        <div>
          <div className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-amber">Credentials</div>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-center gap-2"><Clock className="h-4 w-4 text-amber" />Flexible Scheduling</li>
            <li>License #{BRAND.license}</li>
            <li>Lutron Pro Certified</li>
            <li>Go Green Financing Partner</li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-start justify-between gap-2 text-xs text-white/40 md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} 7 Electric Advice. All Rights Reserved.</span>
        <span>Los Angeles, CA · License #{BRAND.license}</span>
      </div>
    </div>
  </footer>
);
